<template>
  <div class="mn606-status-bar" type="flex">
    <el-row type="flex" class="overall-status" justify="end">
      <!-- <el-col tag="span" :span="4">
        {{$t('设备联网方式')}}：
        <span :class="0 | alarmClass">{{ networkMode | networkHandler }}</span>
      </el-col> -->
      <el-col tag="span" :span="stateSpan">
        {{ $t('报警状态') }}：
        <span :class="alarmStatus | alarmClass">{{ alarmStatus | alarmTextI18n }}</span>
      </el-col>
      <el-col tag="span" :span="stateSpan">
        {{ $t('运行状态') }}：
        <span :class="runState | runClass">{{ runState | runTextI18n }}</span>
      </el-col>
    </el-row>
    <div class="common-border pump-status-wrap mt-15">
      <div class="pump-status" v-for="item in opts" :key="item.prop">
        <div class="label">
          <span :class="['iconfont', item.icon]"></span>
          <span>{{ $t(item.name) }}</span>
        </div>
        <span class="value">
          {{ item.formatter ? item.formatter(model[item.prop]) : model[item.prop] }}
          {{ getUnit(item) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { tools } from '../utils';
import { isEmpty } from '@/utils/is';

export default {
  props: {
    networkMode: {
      type: Number,
      default: 0
    },
    alarmStatus: {
      type: Number,
      default: 0
    },
    runState: {
      type: Number,
      default: 0
    },
    pumpStatus: {
      type: Object,
      default: () => ({
        install: 0,
        run: 0
      })
    },
    model: {
      type: Object,
      default: () => ({})
    },
    opts: {
      type: Array,
      default: () => []
    }
  },
  filters: tools,
  computed: {
    stateSpan() {
      return this.isMobile || !this.isChinese ? 6 : 4;
    }
  },
  methods: {
    isEmpty,
    getUnit(item) {
      if (item.unitNeedI18n) {
        return this.$t(item.unit);
      } else {
        return item.unit;
      }
    }
  }
};
</script>

<style lang="scss">
.is-mobile {
  .mn606-status-bar {
    .pump-status-wrap {
      padding: 8px 0;
      font-size: 14px;

      .pump-status {
        width: 33.33%;
        padding: 4px 0;

        .label {
          margin-right: 6px;
        }
      }
    }

    .overall-status {
      .el-col {
        font-size: 14px;
        padding-left: 15px;
      }
    }

    .iconfont {
      font-size: 17px;
    }
  }
}

.mn606-status-bar {
  .col-btn {
    color: #49c7c3;

    cursor: pointer;

    &:hover {
      color: #3da4a2;
      border-color: transparent;
      background-color: transparent;
    }
  }

  .iconfont {
    font-size: 20px;
    color: $normal-color;
  }

  .pump-status-wrap {
    height: 110px !important;

    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;

    font-size: 18px;

    .pump-status {
      display: flex;
      width: 25%;
      justify-content: center;
      align-items: center;

      .label {
        width: 50%;
        text-align: right;
        margin-right: 8px;

        &::after {
          content: ':';
        }
      }

      .value {
        flex: 1;
      }
    }
  }

  .overall-status {
    font-weight: bold;
  }
  .el-col {
    font-size: 18px;
    padding-left: 20px;
    text-align: center;
  }
}
</style>
